import { FaqSection } from '@pass-frontend/abyss/common/components/faq-section/ui';
import { useIntl } from '@pass-frontend/common/i18n';
import { env } from '@pass-frontend/features/configuration/util';

export function Faq() {
  const { t } = useIntl();
  const { FF_ENABLE_YOUR_PERKS } = env();

  const QuesAns = [
    {
      question: t('faq.whatIsOnePassQue'),
      answer: FF_ENABLE_YOUR_PERKS
        ? t('faq.whatIsOnePassYourPerksAns')
        : t('faq.whatIsOnePassAns'),
    },
    {
      question: t('faq.whoCanUseQue'),
      answer: t('faq.whoCanUseAns'),
    },
    {
      question: t('faq.howMuchItCostsQue'),
      answer: t('faq.howMuchItCostAns'),
    },
    {
      question: t('faq.howToStartQue'),
      answer: t('faq.howToStartAns'),
    },
  ];

  return <FaqSection quesAns={QuesAns} />;
}
